import { render, staticRenderFns } from "./aftersalesManagementList.vue?vue&type=template&id=7d856d9a&scoped=true"
import script from "./aftersalesManagementList.vue?vue&type=script&lang=js"
export * from "./aftersalesManagementList.vue?vue&type=script&lang=js"
import style0 from "./aftersalesManagementList.vue?vue&type=style&index=0&id=7d856d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d856d9a",
  null
  
)

export default component.exports